import * as common from '@/store/common/mutation-types';
export const SEARCH_PARAMS = 'SEARCH_PARAMS';
export const STATE_INIT = 'STATE_INIT';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const SELECTED_ROWS = 'SELECTED_ROWS';
export const RESULT_MASTER = 'RESULT_MASTER';

export default {
	...common,
	SEARCH_PARAMS,
	STATE_INIT,
	DEFAULT_ASSIGN,
	SELECTED_ROWS,
	RESULT_MASTER
};
